/**
 * @generated by @interxfi/j5-codegen (Plugin: NormalizedQueryPlugin) - do not edit */

import type { ExcRouteV1FixSessionEvent } from '@interxfi/types';
import { schema } from 'normalizr';

export const EXC_ROUTE_V1_FIX_SESSION_EVENT_ENTITY_NAME = 'exc.route.v1.FixSessionEvent';
export const excRouteV1FixSessionEventEntity = new schema.Entity<ExcRouteV1FixSessionEvent>(EXC_ROUTE_V1_FIX_SESSION_EVENT_ENTITY_NAME, {}, { idAttribute: (entity: ExcRouteV1FixSessionEvent) => `${entity.metadata?.eventId}` });

